'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var classnames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

var ErrorMessage = function ErrorMessage(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement("span", {
    className: classnames__default['default']('ds-atom-error-message', className)
  }, children);
};

ErrorMessage.propTypes = {
  /**
   * Standard string prop to specify an addition al CSS class name to be added to the
   * output root.
   */
  className: PropTypes__default['default'].string,
  children: PropTypes__default['default'].node.isRequired
};
ErrorMessage.defaultProps = {
  className: ''
};

module.exports = ErrorMessage;
